import React from 'react';
import { useTranslation } from '../../i18n';
import './SkipLinks.css';

export const SkipLinks: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="skip-links">
      <a 
        href="#main-content" 
        className="skip-link"
        aria-label={t('accessibility.navigation.skipToMain')}
      >
        {t('accessibility.navigation.skipToMain')}
      </a>
      <a 
        href="#navigation" 
        className="skip-link"
        aria-label={t('accessibility.navigation.skipToNavigation')}
      >
        {t('accessibility.navigation.skipToNavigation')}
      </a>
    </div>
  );
};

export default SkipLinks;